module.exports = __webpack_public_path__ + "media/customizations/lewiscommunities/back-dc0074292ea21f43681f87a11928c628.jpg";